import { useQuery } from '@tanstack/react-query';
import { getWorkspaceFonts } from '@/api/workspaces.api';
/** Invalidate on sign-out via `queryClient.removeQueries({ queryKey: WORKSPACE_FONTS_QUERY_KEY_ROOT })`. */
export const WORKSPACE_FONTS_QUERY_KEY_ROOT = ['workspace-fonts'] as const;

type UseWorkspaceFontsQueryOptions = {
  enabled: boolean;
};

/**
 * GET `/v1/workspaces/{workspaceId}/fonts`. Disabled when `workspaceId` is missing or `enabled` is false.
 */
export function useWorkspaceFontsQuery(workspaceId: string | undefined, options: UseWorkspaceFontsQueryOptions) {
  return useQuery({
    queryKey: [...WORKSPACE_FONTS_QUERY_KEY_ROOT, workspaceId],
    queryFn: () => getWorkspaceFonts(workspaceId!),
    enabled: Boolean(workspaceId) && options.enabled,
    retry: false,
    staleTime: Infinity,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
}
